import Header from '../Header';
import Footer from '../Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Privacy Policy
            </h1>

            <p className="text-sm text-gray-500 mb-8">
              Last updated: February 27, 2026
            </p>

            <div className="prose prose-gray max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Our commitment to privacy
                </h2>
                <p className="text-gray-700 mb-4">
                  At Pabs, we take your privacy seriously. This policy explains how we
                  collect, use, and protect your information when you use our strategic
                  planning platform.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Information we collect
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Account information (name, email, password)</li>
                  <li>Strategic plans and briefs you create</li>
                  <li>Usage data and analytics</li>
                  <li>MCP integration tokens and connection data</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  How we use your information
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>To provide and improve our strategic planning services</li>
                  <li>To generate AI-assisted strategy and analysis</li>
                  <li>To communicate with you about your account and plans</li>
                  <li>To ensure security and prevent fraud</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  What we DON'T do with your data
                </h2>
                <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                  <ul className="space-y-3 text-gray-900">
                    <li className="flex items-start gap-3">
                      <span className="text-green-600 font-bold">✓</span>
                      <span><strong>No AI training:</strong> We never use your strategic
                      plans, briefs, or decisions to train AI models.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-green-600 font-bold">✓</span>
                      <span><strong>No data selling:</strong> We don't sell, rent, or
                      share your strategic information with third parties.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-green-600 font-bold">✓</span>
                      <span><strong>No unauthorized access:</strong> Your data is
                      encrypted at rest and only accessible by you.</span>
                    </li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Data security
                </h2>
                <p className="text-gray-700 mb-4">
                  We implement industry-standard security measures including:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Encryption of data at rest and in transit</li>
                  <li>Secure authentication with hashed passwords</li>
                  <li>Regular security audits and updates</li>
                  <li>Time-limited MCP tokens with revocation controls</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  MCP integrations and third-party access
                </h2>
                <p className="text-gray-700 mb-4">
                  When you connect external AI builders via MCP:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Access is read-only and scoped to specific plans</li>
                  <li>Tokens expire after 24 hours</li>
                  <li>You can revoke access at any time</li>
                  <li>Third-party tools operate under their own privacy policies</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Your rights
                </h2>
                <p className="text-gray-700 mb-4">You have the right to:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Access your data at any time</li>
                  <li>Export your strategic plans and documents</li>
                  <li>Delete your account and all associated data</li>
                  <li>Opt out of marketing communications</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Contact us
                </h2>
                <p className="text-gray-700">
                  If you have questions about this privacy policy or how we handle your data,
                  please contact us at{' '}
                  <a href="mailto:privacy@pabs.co.nz" className="text-blue-600 hover:text-blue-700">
                    privacy@pabs.co.nz
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
